// Criteria are plain data. A criterion value is either:
//   - a plain value, matched with ===
//   - an array, matched by membership
//   - { not: [...] }, matched by absence from the list
// `permission` is a permission name, or a list of names of which holding any
// one is enough, checked against context.permissions. A super user holds every
// permission. Every other key must exist on the context, so a typo in a
// section registry throws.

const isNegation = (criterion) =>
  criterion !== null &&
  typeof criterion === 'object' &&
  !Array.isArray(criterion) &&
  'not' in criterion

const matchValue = (criterion, actual) => {
  if (isNegation(criterion)) return !criterion.not.includes(actual)
  if (Array.isArray(criterion)) return criterion.includes(actual)
  return criterion === actual
}

const matchPermission = (criterion, context) => {
  const names = Array.isArray(criterion) ? criterion : [criterion]
  if (names.length === 0 || !names.every((name) => typeof name === 'string')) {
    // permission is exempt from the context-key check, so refuse a malformed
    // criterion (e.g. { not: [...] }) loudly rather than hiding the section
    throw new Error(
      'Invalid "permission" criterion: expected a permission name or a list of names'
    )
  }
  if (context.isSuperUser === true) return true
  if (!Array.isArray(context.permissions)) return false
  return names.some((name) => context.permissions.includes(name))
}

const matches = (criteria, context) => {
  const keys = Object.keys(criteria)
  keys.forEach((key) => {
    if (
      key !== 'permission' &&
      !Object.prototype.hasOwnProperty.call(context, key)
    ) {
      throw new Error(
        `Unknown criteria key "${key}": not a field of the parcel context`
      )
    }
  })
  return keys.every((key) =>
    key === 'permission'
      ? matchPermission(criteria[key], context)
      : matchValue(criteria[key], context[key])
  )
}

export { matches }
